import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import c from 'classnames';

import FileInput from '../FileInput';
import { inputStyle, placeholderPosition } from './styles';
import { UploadProps } from './types';

const Upload = (props: UploadProps) => {
  const {
    accept,
    className,
    disabled,
    error,
    formControlProps,
    multiple,
    name,
    onChange,
    onFileSelectError,
    placeholder,
  } = props;

  return (
    <FormControl {...formControlProps} className="w-full h-full">
      <Box
        className={c(
          className,
          'border-dashed rounded-8 relative border w-full h-full',
          error ? 'border-border-error' : 'border-border-dark',
        )}>
        <FileInput
          accept={accept}
          className={c(inputStyle, 'absolute z-10', !disabled && 'cursor-pointer')}
          disabled={disabled}
          multiple={multiple}
          name={name}
          onChange={onChange}
          onFileSelectError={onFileSelectError}
        />
        <Box
          className={c(
            placeholderPosition,
            'absolute flex opacity-25 cursor-pointer items-center',
          )}>
          {placeholder}
        </Box>
      </Box>
    </FormControl>
  );
};

export default React.memo(Upload);
